export const actionItem = {
    region: '',
    language: '',
    articles: [],
    milestones: [],
    get schema() {
        return {
            title: 'Action Item',
            type: 'object',
            properties: {
                impact: {
                    title: 'Impact',
                    type: 'string',
                    default: 'low',
                    enum: ['low', 'medium', 'high', 'not-applicable'],
                },
                priorityRank: {
                    title: 'Priority Rank',
                    type: 'integer',
                    minimum: 0,
                    maximum: 9999,
                },
                content: {
                    title: 'Content',
                    type: 'string',
                    format: 'textarea',
                },
                getStarted: {
                    title: 'Get Started',
                    type: 'string',
                },
                getStartedDescription: {
                    title: 'Get Started Description',
                    type: 'string',
                    format: 'textarea',
                },
                customBenefitCard: {
                    title: 'Custom Benefit Card',
                    type: 'array',
                    items: {
                        type: 'string',
                        title: 'Custom Benefit Card Entry',
                    },
                },
                customBenefitGetStartedLink: {
                    title: 'Custom Benefit Get Started Link',
                    type: 'array',
                    items: {
                        type: 'string',
                        title: 'Custom Benefit Get Started Link Entry',
                    },
                },
                suggestedResources: {
                    title: 'Suggested Resources',
                    type: 'array',
                    items: {
                        type: 'object',
                        title: 'Suggested Resources Entry',
                        properties: {
                            title: {
                                title: 'Title',
                                type: 'string',
                                enum: [''].concat(this.articles
                                    .filter((a) => a.region === this.region && a.language === this.language)
                                    .sort((a, b) => a.title.localeCompare(b.title))
                                    .map((a) => a.title)),
                            },
                            slug: {
                                title: 'Slug',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                            type: {
                                title: 'Content Type',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                            thumbnail: {
                                title: 'Thumbnail',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                        },
                    },
                },
                relatedMilestones: {
                    title: 'Related Milestones',
                    type: 'array',
                    items: {
                        type: 'object',
                        title: 'Related Milestones Entry',
                        properties: {
                            title: {
                                title: 'Title',
                                type: 'string',
                                enum: [''].concat(this.milestones
                                    .filter((a) => a.region === this.region && a.language === this.language)
                                    .sort((a, b) => a.title.localeCompare(b.title))
                                    .map((a) => a.title)),
                            },
                            slug: {
                                title: 'Slug',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                            id: {
                                title: 'Id',
                                type: 'string',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                            scoringLevel: {
                                title: 'Scoring Level',
                                type: 'integer',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                            _legacyId: {
                                title: 'Legacy ID',
                                type: 'integer',
                                options: {
                                    inputAttributes: {
                                        class: 'disabled',
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    },
};
//# sourceMappingURL=actionItemJsonEditorConfig.js.map